// extracted by mini-css-extract-plugin
export default {"certificateCard":"Certificate_certificateCard__22ivJ","certImg":"Certificate_certImg__owKca"};